import React from 'react';

import { FormFieldI } from '../types';

import {
  FilterBorder,
  FormDropdownWrapper,
  FormDropdownOptions,
  FormOptionsWrapper,
  InputSelection,
} from './styles';

interface Props {
  formField: FormFieldI;
  active: boolean;
  onDropdownChange: (...args: any[]) => any;
  selectedValue?: string;
  setActiveDropdown?: React.Dispatch<React.SetStateAction<string | null>>;
}

const FormDropdown = ({
  formField,
  active = false,
  onDropdownChange,
  selectedValue,
  setActiveDropdown,
}: Props) => {
  const tokenize = (name) => name
    .toLowerCase()
    .replace(/[^A-z0-9+()*-\s]/g, '')
    .replace(/\s/g, '-');

  return (
    <FormDropdownWrapper className={active ? 'visible' : ''}>
      {formField?.fieldValues?.map((option) => (
        <FormOptionsWrapper key={`${formField.fieldName}-${option}`}>
          <FilterBorder>
            <FormDropdownOptions
              key={option}
              htmlFor={tokenize(`${formField.fieldName}-${option}`)}
            >
              {option}
            </FormDropdownOptions>
            <InputSelection
              type="radio"
              id={tokenize(`${formField.fieldName}-${option}`)}
              className="radio"
              checked={option === selectedValue}
              onChange={() => {
                onDropdownChange(formField.fieldName, option);
              }}
              onClick={() => {
                // Close the dropdown
                if (setActiveDropdown) {
                  setActiveDropdown(null);
                }
              }}
            />
          </FilterBorder>
        </FormOptionsWrapper>
      ))}
    </FormDropdownWrapper>
  );
};

export default FormDropdown;
